import { makeEntityScaffold } from '@classpass/saga-tools';
import LocationDeriver from 'derivers/Location';

const KEY = 'SAGA.API.GLS';
const DEFAULT_LOCALE_INFO = {
  address_fields: {
    address_line_1: 'REQUIRED',
    address_line_2: 'OPTIONAL',
    city: 'REQUIRED',
    postal_code: 'REQUIRED',
    state_code: 'REQUIRED',
  },
};

export const getAddressRequirements = makeEntityScaffold(
  `${KEY}.GET_LOCALE_INFO`,
  (client, countryShortCode) =>
    client.gls
      .getLocaleInfo(countryShortCode)
      .then(data => LocationDeriver.addressRequirements(data))
      .catch(() => LocationDeriver.addressRequirements(DEFAULT_LOCALE_INFO)),
  { defaultKey: [1] }
);

export const glsLocation = makeEntityScaffold(
  `${KEY}.GLS_USER_LOCATION`,
  (client, latitude, longitude) =>
    client.gls.getUserLocationV2({
      // A precision of 2 decimal points (0.68 miles) is sufficient for our purposes.
      // Having 2 decimal points will increase our cache hit rate.
      latitude: Number(latitude).toFixed(2),
      longitude: Number(longitude).toFixed(2),
    }),
  { defaultKey: [1, 2] }
);
